// @ts-nocheck
import { Plugin } from '/codebuild/output/src2674075065/src/app/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','dva','getInitialState','initialStateConfig','locale','locale','request',],
});

export { plugin };
